const Config = {
    trackingLink: 'https://spothero.com/search?',
    destinationId: 1,
    events: [],
    destinationName: '',
    variant: 'base',
    primaryBGColor: '#ffffff',
    secondaryBGColor: '#f6f7f9',
    secondaryHoverBGColor: '#f6f7f9',
    buttonColor: '#1271eb',
    buttonColorHover: '#1d58f2',
    buttonTextColor: '#ffffff',
    primaryTextColor: '#000000',
    secondaryTextColor: '#5c7995',
    fontLink: '',
    fontName: '',
};

export default Config;
